import {DOCUMENT} from '@angular/common';
import {Component, HostListener, Inject, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ADD, EDIT} from 'src/app/app-routing.module';
import {environment} from "@environment";
import {AbstractComponent} from "@components";
import {Organiser} from "@model";
import {ExportService, OrganiserService} from "@services";
import {debounceTime, distinctUntilChanged} from 'rxjs';
import {FindOrganisersRequest} from 'src/app/model/find-organisers-request';

@Component({
  selector: 'app-list-of-organisers',
  templateUrl: './list-of-organisers.component.html',
  styleUrls: ['./list-of-organisers.component.scss']
})
export class ListOfOrganisersComponent extends AbstractComponent implements OnInit {
  @Input() organisers: Organiser[] = [];
  @Input() filteredOrganisers: Organiser[] = [];

  environment: any = environment;
  showFabButton: boolean = false;
  name: string = "";

  constructor(private router: Router, private route: ActivatedRoute, private organiserService: OrganiserService,
              @Inject(DOCUMENT) private document: Document, private exportService: ExportService) {
    super();
  }

  ngOnInit() {
    this.organiserService.setCurrentOrganiser(undefined);
    this.filteredOrganisers = this.organisers;
    this.subsribeToRouteDataChange();
  }

  subsribeToRouteDataChange() {
    this.subscriptions.push(this.route.queryParams.pipe(debounceTime(environment.fullTextSearchDelay),
        distinctUntilChanged()).subscribe((queryParams: any) => {
        this.name = queryParams.name ? queryParams.name : "";
        this.filterOrganisers();
      })
    );
  }

  downloadOrganisers(type: string) {
    this.exportService.downloadOrganisers(type, this.createFilter());
  }

  createFilter() {
    return FindOrganisersRequest.createOrganisersRequest({text: this.name !== "" ? this.name : undefined});
  }

  private changeQueryParams() {
    let queryParams: { [key: string]: any } = {};

    if (this.name && this.name.length > 0) {
      queryParams['name'] = this.name;
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      replaceUrl: true,
    });
  }

  @HostListener('window:scroll')
  toggleFabButton() {
    this.showFabButton = window.pageYOffset != 0;
  }


  scrollToTop(): void {
    return this.document.body.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start'
    });
  }

  trackByFn(index: number, item: Organiser) {
    return item.id;
  }

  handleSearchInput(value: string | Event): void {
    if (typeof value === 'string') {
      this.name = value.trim();
    } else {
      this.name = ((value.target as HTMLInputElement).value ?? "").trim();
    }
    this.changeQueryParams();
  }


  onEditOrganiser(organiser: Organiser) {
    if (organiser && organiser.id) {
      this.organiserService.setCurrentOrganiser(organiser);
      this.router.navigate([EDIT], {queryParams: {organiserId: organiser?.id}, relativeTo: this.route});
    }
  }

  onAddOrganiser() {
    this.organiserService.currentOrganiser.next(undefined);
    this.router.navigate([ADD], {relativeTo: this.route});
  }

  filterOrganisers() {
    let filtered: Organiser[] = this.organisers.filter((organiser: Organiser) => this.filterFunction(organiser));
    this.filteredOrganisers = filtered.length > 0 ? filtered : [];
  }

  filterFunction(organiser: Organiser): boolean {
    if (this.name) {
      let filterName: string = this.name.toLowerCase() ?? "";
      return !!(organiser.name?.toLowerCase().includes(filterName) ||
        organiser.website?.toLowerCase().includes(filterName));
    }
    return true;
  }
}


